// ==========================================
// 新版烟花粒子系统 - 春节主题
// ==========================================

// 春节主题颜色配置 - 红黄金橘橙色调
const SPRING_FESTIVAL_COLORS = {
  // 小烟花颜色组
  small: [
    ['#ff0000', '#ff3333', '#ff6666', '#ff9999'], // 红色系
    ['#ffd700', '#ffed4e', '#fff176', '#fff9c4'], // 金色系
    ['#ff8c00', '#ffa500', '#ffb347', '#ffcc80'], // 橙色系
    ['#ff4500', '#ff6347', '#ff7f50', '#ffa07a'], // 橘色系
    ['#ff6b6b', '#ff8787', '#ffa3a3', '#ffb3b3'], // 粉红色系
    ['#ffd700', '#ffed4e', '#ffeb3b', '#fff176'], // 黄色系
  ],
  // 大烟花颜色组（更丰富）
  large: [
    ['#ff0000', '#ff3333', '#ff6666', '#ffd700', '#ffed4e'], // 红金渐变
    ['#ffd700', '#ffed4e', '#fff176', '#fff9c4', '#ffffff'], // 金白渐变
    ['#ff6b6b', '#ff8c00', '#ffa500', '#ffd700', '#ffed4e'], // 红橙金渐变
    ['#ff0000', '#ff4500', '#ff6347', '#ff8c00', '#ffa500'], // 红橘橙渐变
    ['#ffd700', '#ffed4e', '#ffeb3b', '#fff176', '#fff9c4'], // 金黄渐变
    ['#ff3333', '#ff6666', '#ff9999', '#ffb3b3', '#ffd700'], // 红粉金渐变
    ['#ff8c00', '#ffa500', '#ffb347', '#ffcc80', '#ffd700'], // 橙金渐变
    ['#ff0000', '#ff3333', '#ffd700', '#ffed4e', '#fff176'], // 红黄渐变
  ]
}

// 更新粒子
function updateParticle(particle, deltaTime = 1) {
  if (particle.life <= 0) return false
  
  const alpha = particle.life / particle.maxLife
  
  // 保存轨迹
  particle.trail.push({ x: particle.x, y: particle.y, alpha })
  if (particle.trail.length > 15) {
    particle.trail.shift()
  }
  
  // 更新位置
  particle.x += particle.vx * deltaTime
  particle.y += particle.vy * deltaTime
  
  // 应用重力
  particle.vy += particle.gravity * deltaTime
  
  // 应用摩擦力
  particle.vx *= Math.pow(particle.friction, deltaTime)
  particle.vy *= Math.pow(particle.friction, deltaTime)
  
  // 减少生命值
  particle.life -= deltaTime
  
  // 更新闪烁相位
  if (particle.twinkle) {
    particle.twinklePhase += 0.3
  }
  
  return particle.life > 0
}

// 绘制粒子
function drawParticle(ctx, particle) {
  const alpha = particle.life / particle.maxLife
  
  // 闪烁效果
  let finalAlpha = alpha
  if (particle.twinkle) {
    finalAlpha = alpha * (0.5 + 0.5 * Math.sin(particle.twinklePhase))
  }
  
  // 绘制拖尾
  if (particle.trail.length > 1) {
    ctx.beginPath()
    ctx.moveTo(particle.trail[0].x, particle.trail[0].y)
    
    for (let i = 1; i < particle.trail.length; i++) {
      const progress = i / particle.trail.length
      const trailAlpha = finalAlpha * progress * 0.5
      const trailSize = particle.size * progress * 0.6
      
      ctx.lineWidth = trailSize
      ctx.strokeStyle = particle.color + Math.floor(trailAlpha * 255).toString(16).padStart(2, '0')
      ctx.lineTo(particle.trail[i].x, particle.trail[i].y)
      ctx.stroke()
      
      ctx.beginPath()
      ctx.moveTo(particle.trail[i].x, particle.trail[i].y)
    }
  }
  
  // 绘制粒子本体
  ctx.beginPath()
  ctx.arc(particle.x, particle.y, particle.size * finalAlpha, 0, Math.PI * 2)
  ctx.fillStyle = particle.color + Math.floor(finalAlpha * 255).toString(16).padStart(2, '0')
  ctx.fill()
  
  // 绘制光晕效果
  if (particle.glow && finalAlpha > 0.3) {
    const glowSize = particle.size * finalAlpha * 3
    const gradient = ctx.createRadialGradient(
      particle.x, particle.y, 0,
      particle.x, particle.y, glowSize
    )
    gradient.addColorStop(0, particle.color + Math.floor(finalAlpha * 100).toString(16).padStart(2, '0'))
    gradient.addColorStop(0.5, particle.color + Math.floor(finalAlpha * 40).toString(16).padStart(2, '0'))
    gradient.addColorStop(1, particle.color + '00')
    
    ctx.beginPath()
    ctx.arc(particle.x, particle.y, glowSize, 0, Math.PI * 2)
    ctx.fillStyle = gradient
    ctx.fill()
  }
}

// ==========================================
// 小烟花类 - 精致小巧
// ==========================================
export class SmallFirework2 {
  constructor() {
    this.particles = []
    this.isActive = false
    this.onComplete = null
  }
  
  start(ctx, x, y, onComplete) {
    this.particles = []
    this.isActive = true
    this.onComplete = onComplete
    
    // 小烟花配置：粒子少但精致
    const colorGroup = SPRING_FESTIVAL_COLORS.small[Math.floor(Math.random() * SPRING_FESTIVAL_COLORS.small.length)]
    
    // 随机选择样式类型（5种样式）
    const styleType = Math.floor(Math.random() * 5)
    let config
    
    if (styleType === 0) {
      // 样式1：菊花型 - 均匀放射
      config = {
        particleCount: 50 + Math.floor(Math.random() * 20), // 50-70 个粒子
        speed: 4 + Math.random() * 3, // 4-7 速度
        gravity: 0.1 + Math.random() * 0.1, // 0.1-0.2 重力
        friction: 0.96 + Math.random() * 0.02, // 0.96-0.98 摩擦力
        life: 50 + Math.floor(Math.random() * 30), // 50-80 生命值
        colors: colorGroup,
        particleSize: 3 + Math.random() * 1.5,
        explosionType: 'chrysanthemum'
      }
    } else if (styleType === 1) {
      // 样式2：柳叶拖尾型 - 长尾巴效果
      config = {
        particleCount: 45 + Math.floor(Math.random() * 15), // 45-60 个粒子
        speed: 3.5 + Math.random() * 2.5, // 3.5-6 速度（稍慢）
        gravity: 0.12 + Math.random() * 0.1, // 0.12-0.22 重力（更重）
        friction: 0.95 + Math.random() * 0.02, // 0.95-0.97 摩擦力（更大阻力）
        life: 60 + Math.floor(Math.random() * 30), // 60-90 生命值（更长）
        colors: colorGroup,
        particleSize: 3 + Math.random() * 1.5,
        explosionType: 'willow'
      }
    } else if (styleType === 2) {
      // 样式3：星爆型 - 快速扩散
      config = {
        particleCount: 55 + Math.floor(Math.random() * 20), // 55-75 个粒子
        speed: 5.5 + Math.random() * 3.5, // 5.5-9 速度（更快）
        gravity: 0.08 + Math.random() * 0.08, // 0.08-0.16 重力（更轻）
        friction: 0.97 + Math.random() * 0.02, // 0.97-0.99 摩擦力（更小阻力）
        life: 45 + Math.floor(Math.random() * 25), // 45-70 生命值（稍短）
        colors: colorGroup,
        particleSize: 3 + Math.random() * 1.5,
        explosionType: 'star'
      }
    } else if (styleType === 3) {
      // 样式4：紧凑型 - 小范围密集
      config = {
        particleCount: 60 + Math.floor(Math.random() * 20), // 60-80 个粒子（更多）
        speed: 3 + Math.random() * 2.5, // 3-5.5 速度（较慢）
        gravity: 0.11 + Math.random() * 0.09, // 0.11-0.2 重力
        friction: 0.96 + Math.random() * 0.02, // 0.96-0.98 摩擦力
        life: 55 + Math.floor(Math.random() * 25), // 55-80 生命值
        colors: colorGroup,
        particleSize: 3 + Math.random() * 1.5,
        explosionType: 'compact'
      }
    } else {
      // 样式5：流星型 - 高速低阻力
      config = {
        particleCount: 40 + Math.floor(Math.random() * 15), // 40-55 个粒子（较少）
        speed: 6 + Math.random() * 4, // 6-10 速度（很快）
        gravity: 0.06 + Math.random() * 0.06, // 0.06-0.12 重力（很轻）
        friction: 0.98 + Math.random() * 0.015, // 0.98-0.995 摩擦力（很小阻力）
        life: 45 + Math.floor(Math.random() * 20), // 45-65 生命值（较短）
        colors: colorGroup,
        particleSize: 3 + Math.random() * 1.5,
        explosionType: 'meteor'
      }
    }
    
    // 根据样式类型创建粒子
    for (let i = 0; i < config.particleCount; i++) {
      let angle, speed
      
      if (config.explosionType === 'chrysanthemum') {
        // 菊花型 - 均匀分布的圆形爆炸
        angle = (i / config.particleCount) * Math.PI * 2 + (Math.random() - 0.5) * 0.3
        speed = config.speed * (0.6 + Math.random() * 0.8)
      } else if (config.explosionType === 'willow') {
        // 柳叶型 - 均匀分布，速度变化较大
        angle = (i / config.particleCount) * Math.PI * 2
        speed = config.speed * (0.5 + Math.random() * 0.7)
      } else if (config.explosionType === 'star') {
        // 星爆型 - 6个方向为主
        const starPoints = 6
        const starAngle = (Math.floor(i / (config.particleCount / starPoints)) / starPoints) * Math.PI * 2
        angle = starAngle + (Math.random() - 0.5) * 0.5
        speed = config.speed * (0.6 + Math.random() * 0.9)
      } else if (config.explosionType === 'compact') {
        // 紧凑型 - 小范围密集，速度变化小
        angle = (i / config.particleCount) * Math.PI * 2 + (Math.random() - 0.5) * 0.2
        speed = config.speed * (0.7 + Math.random() * 0.6)
      } else {
        // 流星型 - 均匀分布，高速
        angle = (i / config.particleCount) * Math.PI * 2 + (Math.random() - 0.5) * 0.25
        speed = config.speed * (0.7 + Math.random() * 0.7)
      }
      
      const colorIndex = Math.floor(Math.random() * config.colors.length)
      const color = config.colors[colorIndex]
      
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: config.life * (0.8 + Math.random() * 0.4),
        maxLife: config.life,
        color,
        size: config.particleSize * (0.7 + Math.random() * 0.6),
        trail: [],
        gravity: config.gravity,
        friction: config.friction,
        glow: Math.random() > 0.4,
        twinkle: Math.random() > 0.6,
        twinklePhase: Math.random() * Math.PI * 2
      })
    }
  }
  
  update(ctx) {
    if (!this.isActive) return false
    
    this.particles = this.particles.filter(p => {
      const alive = updateParticle(p)
      if (alive) {
        drawParticle(ctx, p)
      }
      return alive
    })
    
    if (this.particles.length === 0) {
      this.isActive = false
      if (this.onComplete) {
        this.onComplete()
      }
      return false
    }
    
    return true
  }
}

// ==========================================
// 大烟花类 - 震撼多层爆炸
// ==========================================
export class LargeFirework2 {
  constructor() {
    this.particles = []
    this.isActive = false
    this.stage = 0
    this.stageTimer = 0
    this.centerX = 0
    this.centerY = 0
    this.onComplete = null
    this.colorGroup = null
  }
  
  start(ctx, x, y, onComplete) {
    this.particles = []
    this.isActive = true
    this.stage = 0
    this.stageTimer = 0
    this.centerX = x
    this.centerY = y
    this.onComplete = onComplete
    
    // 随机选择颜色组
    this.colorGroup = SPRING_FESTIVAL_COLORS.large[Math.floor(Math.random() * SPRING_FESTIVAL_COLORS.large.length)]
    
    // 第一层爆炸 - 主爆炸
    this.createExplosion(x, y, 1.0, 120, 6, 0.08)
  }
  
  createExplosion(x, y, scale, particleCount, speed, gravity) {
    const count = Math.floor(particleCount * scale)
    
    for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2 + (Math.random() - 0.5) * 0.2
      const particleSpeed = speed * scale * (0.7 + Math.random() * 0.6)
      const colorIndex = Math.floor(Math.random() * this.colorGroup.length)
      const color = this.colorGroup[colorIndex]
      
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * particleSpeed,
        vy: Math.sin(angle) * particleSpeed,
        life: (80 + Math.random() * 40) * scale,
        maxLife: (80 + Math.random() * 40) * scale,
        color,
        size: (3 + Math.random() * 2) * scale,
        trail: [],
        gravity: gravity,
        friction: 0.97,
        glow: Math.random() > 0.3,
        twinkle: Math.random() > 0.5,
        twinklePhase: Math.random() * Math.PI * 2
      })
    }
  }
  
  update(ctx) {
    if (!this.isActive) return false
    
    this.stageTimer++
    
    // 第二层爆炸 - 延迟 20 帧，4个方向
    if (this.stage === 0 && this.stageTimer === 20) {
      this.stage = 1
      const offsets = [
        { x: -50, y: -30 },
        { x: 50, y: -30 },
        { x: -30, y: 50 },
        { x: 30, y: 50 },
      ]
      for (const offset of offsets) {
        this.createExplosion(
          this.centerX + offset.x,
          this.centerY + offset.y,
          0.6, 80, 5, 0.1
        )
      }
    }
    
    // 第三层爆炸 - 延迟 35 帧，8个方向
    if (this.stage === 1 && this.stageTimer === 35) {
      this.stage = 2
      for (let i = 0; i < 8; i++) {
        const angle = (i / 8) * Math.PI * 2
        const distance = 60 + Math.random() * 20
        this.createExplosion(
          this.centerX + Math.cos(angle) * distance,
          this.centerY + Math.sin(angle) * distance,
          0.4, 50, 4, 0.12
        )
      }
    }
    
    // 第四层爆炸 - 延迟 50 帧，中心小爆炸
    if (this.stage === 2 && this.stageTimer === 50) {
      this.stage = 3
      this.createExplosion(this.centerX, this.centerY, 0.3, 40, 3, 0.15)
    }
    
    // 更新和绘制粒子
    this.particles = this.particles.filter(p => {
      const alive = updateParticle(p)
      if (alive) {
        drawParticle(ctx, p)
      }
      return alive
    })
    
    // 检查是否完成
    if (this.particles.length === 0 && this.stage >= 3) {
      this.isActive = false
      if (this.onComplete) {
        this.onComplete()
      }
      return false
    }
    
    return true
  }
}